import React, {
    useCallback,
    useEffect,
    useMemo,
    useState,
} from "react";

import api from "../../api/api";

import Swal from "sweetalert2";

import {
    Layout,
    Card,
    Avatar,
    Typography,
    Button,
    Input,
    Select,
    Space,
    Row,
    Col,
    Divider,
    Tag,
    Modal,
    Form,
    DatePicker,
    Empty,
    Spin,
    Badge,
    Tooltip,
    Skeleton,
    ConfigProvider,
} from "antd";

import {
    LikeOutlined,
    LikeFilled,
    MessageOutlined,
    EditOutlined,
    DeleteOutlined,
    UserOutlined,
    BookOutlined,
    CalendarOutlined,
    TeamOutlined,
    SendOutlined,
    ClockCircleOutlined,
    FileTextOutlined,
    SearchOutlined,
    ReloadOutlined,
    CheckCircleOutlined,
    ExclamationCircleOutlined,
    CommentOutlined,
    MoreOutlined,
    ArrowRightOutlined,
} from "@ant-design/icons";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

import defaultAvatar from "./maleee.jpg";

dayjs.extend(relativeTime);

const {
    Title,
    Text,
    Paragraph,
} = Typography;

const { TextArea } = Input;

const AssignmentView = () => {

    /* ============================================================
       STATES
    ============================================================ */

    const [
        assignments,
        setAssignments,
    ] = useState([]);

    const [
        subjects,
        setSubjects,
    ] = useState([]);

    const [
        filterSubject,
        setFilterSubject,
    ] = useState("");

    const [
        searchTerm,
        setSearchTerm,
    ] = useState("");

    const [
        loading,
        setLoading,
    ] = useState(true);

    const [
        teacher,
        setTeacher,
    ] = useState(null);

    const [
        commentsLoading,
        setCommentsLoading,
    ] = useState({});

    const [
        actionLoading,
        setActionLoading,
    ] = useState({});

    const [
        expandedComments,
        setExpandedComments,
    ] = useState({});

    const [
        commentsData,
        setCommentsData,
    ] = useState({});

    const [
        commentInput,
        setCommentInput,
    ] = useState({});

    const [
        replyInput,
        setReplyInput,
    ] = useState({});

    const [
        activeReplyBox,
        setActiveReplyBox,
    ] = useState(null);

    const [
        editModalOpen,
        setEditModalOpen,
    ] = useState(false);

    const [
        editAssignment,
        setEditAssignment,
    ] = useState(null);

    const [
        editSaving,
        setEditSaving,
    ] = useState(false);

    const [
        editForm,
    ] = Form.useForm();

    const [
        gradeClasses,
        setGradeClasses,
    ] = useState([]);

    const [
        allSubjects,
        setAllSubjects,
    ] = useState([]);


    /* ============================================================
       CAYEP DESIGN SYSTEM
    ============================================================ */

    const colors = {
        primary: "#9f4a00",
        primaryDark: "#ff9900",
        secondary: "#0F8B7D",
        teal: "#14B8A6",
        cyan: "#22C7D6",

        gold: "#F4B942",
        yellow: "#F7C948",
        orange: "#E88A2E",

        green: "#2FA36B",
        blue: "#2563A6",
        sky: "#38A9D6",

        text: "#102A27",
        muted: "#647773",

        border: "#DDE9E6",
        soft: "#F3F8F7",
        hover: "#EAF5F2",

        surface: "#FFFFFF",
        page: "#F5F9F8",

        danger: "#D64545",

        shadow:
            "0 12px 35px rgba(7,82,71,.10)",

        shadowHover:
            "0 18px 45px rgba(7,82,71,.16)",
    };


    /* ============================================================
       GLOBAL CSS
    ============================================================ */

    useEffect(() => {

        const styleId =
            "cayep-assignment-community-styles";

        let style =
            document.getElementById(
                styleId
            );

        if (!style) {

            style =
                document.createElement(
                    "style"
                );

            style.id = styleId;

            document.head.appendChild(
                style
            );
        }

        style.innerHTML = `

        /* ========================================================
           PAGE
        ======================================================== */

        .assignment-page {
            min-height: 100vh;

            background:
                radial-gradient(
                    circle at 5% 0%,
                    rgba(20,184,166,.09),
                    transparent 26%
                ),
                radial-gradient(
                    circle at 95% 10%,
                    rgba(34,199,214,.06),
                    transparent 22%
                ),
                #F5F9F8;

            color: #102A27;
        }

        .assignment-shell {
            width: 100%;
            max-width: 1480px;
            margin: 0 auto;
        }


        /* ========================================================
           COMMUNITY HERO
        ======================================================== */

        .community-hero {
            position: relative;
            overflow: hidden;

            min-height: 190px;

            border-radius: 26px !important;
            border: 0 !important;

            background:
                linear-gradient(
                    135deg,
                    #3a0150 0%,
                    #1a151a 45%,
                    #0F8B7D 72%,
                    #3a1e00 100%
                ) !important;

            box-shadow:
                0 20px 55px rgba(
                    7,
                    82,
                    71,
                    .18
                );
        }

        .community-hero::before {
            content: "";

            position: absolute;

            width: 330px;
            height: 330px;

            right: -100px;
            top: -180px;

            border-radius: 50%;

            background:
                rgba(
                    255,
                    255,
                    255,
                    .08
                );
        }

        .community-hero::after {
            content: "";

            position: absolute;

            width: 230px;
            height: 230px;

            right: 22%;
            bottom: -170px;

            border-radius: 50%;

            background:
                rgba(
                    255,
                    255,
                    255,
                    .055
                );
        }

        .community-hero-body {
            position: relative;
            z-index: 2;

            padding: 30px;
        }

        .community-profile {
            display: flex;
            align-items: center;

            gap: 18px;

            min-width: 0;
        }

        .community-profile-avatar {
            flex: 0 0 auto;

            border:
                4px solid
                rgba(
                    255,
                    255,
                    255,
                    .90
                );

            box-shadow:
                0 10px 30px
                rgba(
                    0,
                    0,
                    0,
                    .20
                );
        }

        .community-profile-copy {
            min-width: 0;
        }

        .community-eyebrow {
            display: block;

            margin-bottom: 5px;

            color:
                rgba(
                    255,
                    255,
                    255,
                    .72
                );

            font-size: 11px;
            font-weight: 800;

            letter-spacing: 1.3px;
            text-transform: uppercase;
        }

        .community-name {
            margin: 0 !important;

            color: #FFFFFF !important;

            font-size: 28px !important;
            font-weight: 850 !important;

            letter-spacing: -.6px;
        }

        .community-description {
            display: block;

            max-width: 650px;

            margin-top: 5px;

            color:
                rgba(
                    255,
                    255,
                    255,
                    .78
                ) !important;

            font-size: 14px !important;
            line-height: 1.6;
        }

        .community-status {
            margin-left: auto;

            display: flex;
            align-items: center;
            gap: 9px;

            padding: 9px 13px;

            border-radius: 999px;

            background:
                rgba(
                    255,
                    255,
                    255,
                    .11
                );

            border:
                1px solid
                rgba(
                    255,
                    255,
                    255,
                    .18
                );

            color: #FFFFFF;

            font-size: 12px;
            font-weight: 750;

            white-space: nowrap;
        }

        .community-status-dot {
            width: 8px;
            height: 8px;

            border-radius: 50%;

            background: #ffb300;

            box-shadow:
                0 0 0 4px
                rgba(
                    132,
                    204,
                    90,
                    .15
                );
        }


        /* ========================================================
           DISCOVERY BAR
        ======================================================== */

        .community-discovery {
            margin-top: 18px;

            padding: 20px 22px;

            border:
                1px solid
                #DDE9E6 !important;

            border-radius: 20px !important;

            background: #FFFFFF !important;

            box-shadow:
                0 8px 28px
                rgba(
                    7,
                    82,
                    71,
                    .055
                );
        }

        .discovery-title {
            margin: 0 !important;

            color: #102A27 !important;

            font-size: 19px !important;
            font-weight: 800 !important;
        }

        .discovery-description {
            display: block;

            margin-top: 3px;

            color: #71827F !important;

            font-size: 13px !important;
        }

        .discovery-controls {
            display: flex;

            align-items: center;

            justify-content: flex-end;

            gap: 9px;
        }

        .community-search {
            width: 245px;
        }

        .community-search .ant-input-affix-wrapper {
            height: 43px;

            border-radius: 12px;

            border-color: #DDE9E6;

            box-shadow: none;
        }

        .community-search
        .ant-input-affix-wrapper:hover,
        .community-search
        .ant-input-affix-wrapper-focused {
            border-color: #14B8A6;
            box-shadow:
                0 0 0 3px
                rgba(
                    20,
                    184,
                    166,
                    .08
                );
        }

        .subject-filter {
            width: 190px;
        }

        .subject-filter .ant-select-selector {
            min-height: 43px !important;

            border-radius: 12px !important;

            border-color:
                #DDE9E6 !important;
        }

        .refresh-button {
            width: 43px !important;
            height: 43px !important;

            border-radius: 12px !important;

            border-color:
                #DDE9E6 !important;

            color: #0B6B5E !important;

            background: #FFFFFF !important;
        }

        .refresh-button:hover {
            background: #EAF5F2 !important;

            border-color:
                #BBD9D3 !important;
        }


        /* ========================================================
           FEED
        ======================================================== */

        .assignment-feed {
            width: 100%;
            max-width: 900px;

            margin:
                24px auto 0;
        }

        .feed-heading {
            display: flex;

            align-items: center;

            justify-content:
                space-between;

            margin-bottom: 12px;

            padding: 0 4px;
        }

        .feed-heading-label {
            color: #647773;

            font-size: 13px;
            font-weight: 700;
        }

        .feed-heading-count {
            color: #0B6B5E;

            font-size: 13px;
            font-weight: 800;
        }


        /* ========================================================
           ASSIGNMENT CARD
        ======================================================== */

        .assignment-card {
            overflow: hidden;

            border-radius: 23px !important;

            border:
                1px solid
                #DDE9E6 !important;

            background: #FFFFFF !important;

            box-shadow:
                0 10px 34px
                rgba(
                    7,
                    82,
                    71,
                    .065
                );

            transition:
                transform .22s ease,
                box-shadow .22s ease,
                border-color .22s ease;
        }

        .assignment-card:hover {
            transform:
                translateY(-2px);

            border-color:
                #BBD9D3 !important;

            box-shadow:
                0 18px 45px
                rgba(
                    7,
                    82,
                    71,
                    .12
                );
        }

        .assignment-card
        .ant-card-body {
            padding: 0 !important;
        }


        /* ========================================================
           POST HEADER
        ======================================================== */

        .post-header {
            display: flex;

            align-items: flex-start;

            gap: 12px;

            padding:
                21px 23px 14px;
        }

        .post-avatar {
            flex: 0 0 auto;

            border:
                2px solid
                #EAF5F2;

            box-shadow:
                0 4px 13px
                rgba(
                    7,
                    82,
                    71,
                    .10
                );
        }

        .post-author-area {
            flex: 1;

            min-width: 0;
        }

        .post-author-line {
            display: flex;

            align-items: center;

            flex-wrap: wrap;

            gap: 7px;
        }

        .post-author-name {
            color: #102A27;

            font-size: 15px;

            font-weight: 800;
        }

        .teacher-badge {
            padding:
                3px 8px !important;

            margin: 0 !important;

            border: 0 !important;

            border-radius: 999px !important;

            background: #EAF5F2 !important;

            color: #0B6B5E !important;

            font-size: 10px !important;

            font-weight: 850 !important;

            letter-spacing: .3px;
        }

        .post-context {
            display: block;

            margin-top: 3px;

            color: #7A8B87;

            font-size: 12px;
        }

        .post-menu {
            flex: 0 0 auto;

            color: #71827F !important;

            border-radius: 10px !important;
        }

        .post-menu:hover {
            background: #F3F8F7 !important;

            color: #0B6B5E !important;
        }


        /* ========================================================
           ASSIGNMENT CONTENT
        ======================================================== */

        .assignment-content {
            padding:
                4px 23px 21px;
        }

        .assignment-title {
            margin: 0 !important;

            color: #102A27 !important;

            font-size: 25px !important;

            line-height: 1.28 !important;

            font-weight: 820 !important;

            letter-spacing:
                -.45px;
        }

        .assignment-intro {
            margin-top: 8px;

            color: #647773;

            font-size: 14px;

            line-height: 1.65;
        }

        .assignment-meta {
            display: flex;

            flex-wrap: wrap;

            gap: 7px;

            margin-top: 15px;
        }

        .assignment-tag {
            display: inline-flex;

            align-items: center;

            gap: 5px;

            margin: 0 !important;

            padding:
                5px 10px !important;

            border-radius: 999px !important;

            font-size: 12px !important;

            font-weight: 700 !important;
        }

        .assignment-description {
            margin:
                15px 0 0 !important;

            color: #425954 !important;

            font-size: 15px !important;

            line-height: 1.75 !important;

            white-space: pre-wrap;

            overflow-wrap: anywhere;
        }


        /* ========================================================
           COMMUNITY PLACEHOLDER
        ======================================================== */

        .assignment-community-note {
            display: flex;

            align-items: flex-start;

            gap: 10px;

            margin-top: 17px;

            padding: 13px 14px;

            border-radius: 15px;

            background:
                linear-gradient(
                    135deg,
                    #F3F8F7,
                    #F8FCFB
                );

            border:
                1px solid
                #E0ECE9;
        }

        .community-note-icon {
            width: 34px;
            height: 34px;

            flex: 0 0 34px;

            display: flex;

            align-items: center;

            justify-content: center;

            border-radius: 10px;

            background: #EAF5F2;

            color: #0B6B5E;
        }

        .community-note-title {
            display: block;

            color: #102A27;

            font-size: 12px;

            font-weight: 800;
        }

        .community-note-text {
            display: block;

            margin-top: 2px;

            color: #71827F;

            font-size: 12px;

            line-height: 1.5;
        }


        /* ========================================================
           DEADLINE
        ======================================================== */

        .assignment-deadline {
            display: flex;

            align-items: center;

            gap: 10px;

            margin-top: 16px;

            padding: 11px 13px;

            border-radius: 14px;

            border: 1px solid;
        }

        .deadline-icon {
            width: 36px;
            height: 36px;

            flex: 0 0 36px;

            display: flex;

            align-items: center;

            justify-content: center;

            border-radius: 10px;

            background: #FFFFFF;
        }

        .deadline-label {
            display: block;

            color: #647773;

            font-size: 10px;

            font-weight: 800;

            letter-spacing: .5px;

            text-transform:
                uppercase;
        }

        .deadline-value {
            display: block;

            margin-top: 2px;

            font-size: 13px;

            font-weight: 800;
        }


        /* ========================================================
           ACTION BAR
        ======================================================== */

        .assignment-actions {
            display: flex;

            align-items: center;

            justify-content:
                space-between;

            gap: 10px;

            padding:
                9px 18px;

            border-top:
                1px solid
                #EDF3F1;

            border-bottom:
                1px solid
                #EDF3F1;

            background:
                #FCFEFD;
        }

        .action-group {
            display: flex;

            align-items: center;

            gap: 3px;
        }

        .social-action {
            height: 38px !important;

            padding:
                0 10px !important;

            border-radius: 11px !important;

            color: #647773 !important;

            font-size: 13px !important;

            font-weight: 700 !important;
        }

        .social-action:hover {
            color: #0B6B5E !important;

            background:
                #EAF5F2 !important;
        }

        .social-action-liked {
            color: #0B6B5E !important;

            background:
                #EAF5F2 !important;
        }

        .action-divider {
            width: 1px;
            height: 21px;

            margin:
                0 4px;

            background: #E3ECEA;
        }


        /* ========================================================
           DISCUSSION
        ======================================================== */

        .assignment-discussion {
            padding:
                20px 23px 25px;

            background:
                linear-gradient(
                    180deg,
                    #F8FCFB 0%,
                    #FFFFFF 100%
                );
        }

        .discussion-header {
            display: flex;

            align-items: center;

            justify-content:
                space-between;

            gap: 12px;
        }

        .discussion-heading {
            display: flex;

            align-items: center;

            gap: 10px;
        }

        .discussion-icon {
            width: 39px;
            height: 39px;

            flex: 0 0 39px;

            display: flex;

            align-items: center;

            justify-content: center;

            border-radius: 12px;

            background:
                linear-gradient(
                    135deg,
                    #075247,
                    #14B8A6
                );

            color: #FFFFFF;

            box-shadow:
                0 7px 17px
                rgba(
                    7,
                    82,
                    71,
                    .15
                );
        }

        .discussion-title {
            display: block;

            color: #102A27;

            font-size: 16px;

            font-weight: 850;
        }

        .discussion-subtitle {
            display: block;

            margin-top: 2px;

            color: #7A8B87;

            font-size: 11px;
        }

        .discussion-count {
            flex: 0 0 auto;
        }

        .discussion-count
        .ant-badge-count {
            min-width: 26px;

            height: 26px;

            line-height: 26px;

            border-radius: 999px;

            background: #EAF5F2;

            color: #0B6B5E;

            box-shadow: none;

            font-size: 11px;

            font-weight: 800;
        }


        /* ========================================================
           COMMENT COMPOSER
        ======================================================== */

        .comment-composer {
            display: flex;

            align-items: flex-start;

            gap: 10px;

            margin-top: 17px;
        }

        .composer-avatar {
            flex: 0 0 40px;

            border:
                2px solid
                #FFFFFF;

            box-shadow:
                0 3px 12px
                rgba(
                    7,
                    82,
                    71,
                    .12
                );
        }

        .composer-content {
            flex: 1;

            min-width: 0;
        }

        .composer-box {
            display: flex;

            align-items: flex-end;

            gap: 7px;

            padding:
                7px 7px 7px 13px;

            border-radius: 17px;

            background: #FFFFFF;

            border:
                1px solid
                #DDE9E6;

            box-shadow:
                0 4px 15px
                rgba(
                    7,
                    82,
                    71,
                    .045
                );

            transition:
                border-color .2s ease,
                box-shadow .2s ease;
        }

        .composer-box:focus-within {
            border-color: #14B8A6;

            box-shadow:
                0 0 0 3px
                rgba(
                    20,
                    184,
                    166,
                    .08
                );
        }

        .composer-box
        .ant-input {
            border: 0 !important;

            box-shadow: none !important;

            background: transparent !important;

            padding:
                5px 0 !important;

            font-size: 14px !important;

            line-height: 1.5 !important;
        }

        .comment-send {
            width: 37px !important;
            height: 37px !important;

            min-width: 37px !important;

            flex: 0 0 37px;

            border: 0 !important;

            border-radius: 12px !important;

            background:
                linear-gradient(
                    135deg,
                    #075247,
                    #0B6B5E,
                    #14B8A6
                ) !important;

            box-shadow:
                0 5px 14px
                rgba(
                    7,
                    82,
                    71,
                    .15
                );
        }


        /* ========================================================
           DISCUSSION LIST
        ======================================================== */

        .comment-list {
            display: flex;

            flex-direction: column;

            gap: 17px;

            margin-top: 20px;
        }

        .comment-item {
            display: flex;

            align-items: flex-start;

            gap: 9px;

            width: 100%;
        }

        /*
           THIS IS THE IMPORTANT PART.
           Avatar and content are immediate siblings.
        */

        .comment-avatar {
            width: 39px !important;
            height: 39px !important;

            min-width: 39px;

            flex: 0 0 39px;

            margin-top: 1px;

            border:
                2px solid
                #FFFFFF;

            box-shadow:
                0 3px 11px
                rgba(
                    7,
                    82,
                    71,
                    .11
                );
        }

        .comment-content {
            flex: 0 1 auto;

            min-width: 0;

            max-width:
                calc(
                    100% - 48px
                );
        }

        .comment-bubble {
            display: inline-block;

            max-width: 100%;

            padding:
                9px 13px 10px;

            border-radius:
                5px 17px 17px 17px;

            background: #FFFFFF;

            border:
                1px solid
                #DDE9E6;

            box-shadow:
                0 3px 13px
                rgba(
                    7,
                    82,
                    71,
                    .045
                );
        }

        .comment-author-line {
            display: flex;

            align-items: center;

            flex-wrap: wrap;

            gap: 6px;
        }

        .comment-author {
            color: #102A27;

            font-size: 13px;

            font-weight: 850;
        }

        .comment-role {
            padding:
                2px 6px;

            border-radius: 999px;

            background: #EAF5F2;

            color: #0B6B5E;

            font-size: 9px;

            font-weight: 850;

            text-transform:
                uppercase;
        }

        .comment-text {
            margin-top: 3px;

            color: #3F5651;

            font-size: 14px;

            line-height: 1.55;

            white-space: pre-wrap;

            overflow-wrap: anywhere;

            word-break: break-word;
        }

        .comment-meta {
            display: flex;

            align-items: center;

            gap: 9px;

            margin-top: 4px;

            padding-left: 3px;
        }

        .comment-time {
            color: #94A19E;

            font-size: 10px;
        }

        .comment-meta-button {
            height: auto !important;

            padding:
                0 !important;

            color: #0B6B5E !important;

            font-size: 11px !important;

            font-weight: 800 !important;
        }

        .comment-meta-button:hover {
            background:
                transparent !important;

            text-decoration:
                underline;
        }


        /* ========================================================
           REPLY COMPOSER
        ======================================================== */

        .reply-composer {
            display: flex;

            align-items: flex-start;

            gap: 8px;

            margin-top: 9px;
        }

        .reply-composer-avatar {
            width: 31px !important;
            height: 31px !important;

            min-width: 31px;

            flex: 0 0 31px;

            border:
                2px solid
                #FFFFFF;
        }

        .reply-input-box {
            display: flex;

            align-items: center;

            gap: 5px;

            flex: 1;

            min-width: 0;

            padding:
                4px 5px 4px 10px;

            border:
                1px solid
                #DDE9E6;

            border-radius: 13px;

            background: #FFFFFF;
        }

        .reply-input-box
        .ant-input {
            border: 0 !important;

            box-shadow: none !important;

            background: transparent !important;

            padding:
                4px 0 !important;

            font-size: 12px !important;
        }

        .reply-send {
            width: 29px !important;
            height: 29px !important;

            min-width: 29px !important;

            border-radius: 9px !important;

            color: #0B6B5E !important;
        }


        /* ========================================================
           REPLIES
        ======================================================== */

        .replies {
            margin-top: 9px;

            margin-left: 17px;

            padding-left: 16px;

            border-left:
                2px solid
                #DDE9E6;
        }

        .reply-item {
            display: flex;

            align-items: flex-start;

            gap: 8px;
        }

        .reply-item + .reply-item {
            margin-top: 11px;
        }

        .reply-avatar {
            width: 31px !important;
            height: 31px !important;

            min-width: 31px;

            flex: 0 0 31px;

            border:
                2px solid
                #FFFFFF;

            box-shadow:
                0 2px 8px
                rgba(
                    7,
                    82,
                    71,
                    .08
                );
        }

        .reply-content {
            flex: 0 1 auto;

            min-width: 0;

            max-width:
                calc(
                    100% - 39px
                );
        }

        .reply-bubble {
            display: inline-block;

            max-width: 100%;

            padding:
                8px 11px;

            border-radius:
                5px 14px 14px 14px;

            background:
                #F3F8F7;

            border:
                1px solid
                #DDE9E6;
        }

        .reply-author {
            display: flex;

            align-items: center;

            flex-wrap: wrap;

            gap: 5px;

            color: #102A27;

            font-size: 12px;

            font-weight: 850;
        }

        .reply-text {
            margin-top: 2px;

            color: #536965;

            font-size: 12px;

            line-height: 1.55;

            white-space: pre-wrap;

            overflow-wrap: anywhere;

            word-break: break-word;
        }

        .reply-meta {
            display: flex;

            gap: 8px;

            margin-top: 3px;

            padding-left: 2px;

            color: #94A19E;

            font-size: 9px;
        }


        /* ========================================================
           EMPTY DISCUSSION
        ======================================================== */

        .discussion-empty {
            display: flex;

            align-items: center;

            flex-direction: column;

            text-align: center;

            padding:
                31px 15px 11px;
        }

        .discussion-empty-icon {
            width: 51px;
            height: 51px;

            display: flex;

            align-items: center;

            justify-content: center;

            border-radius: 16px;

            background: #EAF5F2;

            color: #0B6B5E;

            font-size: 21px;
        }

        .discussion-empty-title {
            margin-top: 11px;

            color: #102A27;

            font-size: 15px;

            font-weight: 850;
        }

        .discussion-empty-text {
            max-width: 450px;

            margin-top: 5px;

            color: #71827F;

            font-size: 12px;

            line-height: 1.6;
        }

        .discussion-empty-action {
            margin-top: 6px;

            padding: 0 !important;

            color: #0B6B5E !important;

            font-size: 12px !important;

            font-weight: 800 !important;
        }


        /* ========================================================
           EMPTY FEED
        ======================================================== */

        .feed-empty {
            padding:
                65px 20px;

            border-radius: 22px;

            border:
                1px solid
                #DDE9E6;

            background: #FFFFFF;

            box-shadow:
                0 10px 30px
                rgba(
                    7,
                    82,
                    71,
                    .05
                );
        }


        /* ========================================================
           MODAL
        ======================================================== */

        .assignment-modal
        .ant-modal-content {
            overflow: hidden;

            border-radius: 20px;

            padding: 0;

            box-shadow:
                0 25px 80px
                rgba(
                    7,
                    82,
                    71,
                    .18
                );
        }

        .assignment-modal
        .ant-modal-header {
            margin: 0;

            padding:
                20px 22px 15px;

            border-bottom:
                1px solid
                #EDF3F1;
        }

        .assignment-modal
        .ant-modal-body {
            padding:
                22px;
        }

        .modal-heading {
            display: flex;

            align-items: center;

            gap: 11px;
        }

        .modal-heading-icon {
            width: 38px;
            height: 38px;

            display: flex;

            align-items: center;

            justify-content: center;

            border-radius: 11px;

            background: #EAF5F2;

            color: #0B6B5E;
        }


        /* ========================================================
           MOBILE
        ======================================================== */

        @media (max-width: 767px) {

            .assignment-page {
                padding:
                    8px 7px 35px !important;
            }

            .community-hero {
                min-height: 0;

                border-radius:
                    20px !important;
            }

            .community-hero-body {
                padding: 21px 18px;
            }

            .community-profile {
                gap: 12px;
            }

            .community-profile-avatar {
                width: 64px !important;
                height: 64px !important;
            }

            .community-name {
                font-size:
                    21px !important;
            }

            .community-description {
                font-size:
                    12px !important;
            }

            .community-status {
                display: none;
            }

            .community-discovery {
                padding:
                    16px;

                border-radius:
                    17px !important;
            }

            .discovery-controls {
                display: grid;

                grid-template-columns:
                    1fr auto;

                gap: 8px;
            }

            .community-search {
                width: 100%;

                grid-column:
                    1 / -1;
            }

            .subject-filter {
                width: 100%;
            }

            .assignment-feed {
                margin-top: 18px;
            }

            .post-header {
                padding:
                    17px 15px 11px;
            }

            .assignment-content {
                padding:
                    4px 15px 18px;
            }

            .assignment-title {
                font-size:
                    21px !important;
            }

            .assignment-intro {
                font-size:
                    13px;
            }

            .assignment-description {
                font-size:
                    14px !important;

                line-height:
                    1.7 !important;
            }

            .assignment-actions {
                padding:
                    7px 9px;
            }

            .social-action {
                padding:
                    0 8px !important;

                font-size:
                    12px !important;
            }

            .assignment-discussion {
                padding:
                    18px 15px 21px;
            }

        }


        /* ========================================================
           SMALL PHONES
        ======================================================== */

        @media (max-width: 480px) {

            .community-profile-avatar {
                width: 55px !important;
                height: 55px !important;
            }

            .community-name {
                font-size:
                    19px !important;
            }

            .community-description {
                display: none;
            }

            .discovery-title {
                font-size:
                    17px !important;
            }

            .discovery-description {
                font-size:
                    12px !important;
            }

            .feed-heading {
                margin-bottom:
                    9px;
            }

            .assignment-card {
                border-radius:
                    19px !important;
            }

            .assignment-tag {
                font-size:
                    11px !important;

                padding:
                    4px 8px !important;
            }

            .action-label {
                display: none;
            }

            .social-action {
                width: 40px;

                padding:
                    0 !important;

                justify-content:
                    center;
            }

            .comment-avatar {
                width: 35px !important;
                height: 35px !important;

                min-width: 35px;
            }

            .comment-content {
                max-width:
                    calc(
                        100% - 44px
                    );
            }

            .comment-bubble {
                padding:
                    8px 11px 9px;
            }

            .comment-text {
                font-size:
                    13px;
            }

            .replies {
                margin-left: 4px;

                padding-left: 10px;
            }

            .reply-avatar {
                width: 28px !important;
                height: 28px !important;

                min-width: 28px;
            }

            .reply-content {
                max-width:
                    calc(
                        100% - 36px
                    );
            }

        }

        `;

        return () => {

            const existing =
                document.getElementById(
                    styleId
                );

            if (existing) {
                existing.remove();
            }

        };

    }, []);


    /* ============================================================
       ALERT HELPERS
    ============================================================ */

    const success = (
        title,
        text
    ) => {

        Swal.fire({
            icon: "success",
            title,
            text,
            timer: 1600,
            showConfirmButton: false,
        });

    };


    const error = (
        title,
        text
    ) => {

        Swal.fire({
            icon: "error",
            title,
            text,
        });

    };


    /* ============================================================
       PROFILE
    ============================================================ */

    const fetchTeacherProfile =
        useCallback(
            async () => {

                try {

                    const res =
                        await api.get(
                            "/api/users/profile/"
                        );

                    setTeacher(
                        res.data
                    );

                } catch (err) {

                    console.log(
                        "Teacher profile error",
                        err
                    );

                }

            },
            []
        );


    /* ============================================================
       ASSIGNMENTS
    ============================================================ */

    const fetchAssignments =
        useCallback(
            async () => {

                try {

                    setLoading(true);

                    const res =
                        await api.get(
                            "/api/assignments/"
                        );

                    const data =
                        Array.isArray(
                            res.data
                        )
                            ? res.data
                            : [];

                    setAssignments(
                        data
                    );

                    const subjectList =
                        [
                            ...new Set(
                                data
                                    .map(
                                        item =>
                                            item.subject_name
                                    )
                                    .filter(
                                        Boolean
                                    )
                            ),
                        ];

                    setSubjects(
                        subjectList
                    );

                } catch (err) {

                    console.error(
                        "Assignment fetch error:",
                        err
                    );

                    error(
                        "Unable to load assignments",
                        "Please refresh the page and try again."
                    );

                } finally {

                    setLoading(
                        false
                    );

                }

            },
            []
        );


    /* ============================================================
       TEACHER SUBJECT DATA
    ============================================================ */

    const fetchTeacherSubjects =
        useCallback(
            async () => {

                try {

                    const res =
                        await api.get(
                            "/api/users/teacher-subjects/"
                        );

                    setGradeClasses(
                        res.data
                            ?.grade_classes ||
                        []
                    );

                    setAllSubjects(
                        res.data
                            ?.subjects ||
                        []
                    );

                } catch (err) {

                    console.log(
                        "Teacher subject error:",
                        err
                    );

                }

            },
            []
        );


    /* ============================================================
       INITIAL LOAD
    ============================================================ */

    useEffect(() => {

        fetchAssignments();

        fetchTeacherProfile();

        fetchTeacherSubjects();

    }, [
        fetchAssignments,
        fetchTeacherProfile,
        fetchTeacherSubjects,
    ]);


    /* ============================================================
       FILTERED ASSIGNMENTS
    ============================================================ */

    const filteredAssignments =
        useMemo(() => {

            const search =
                searchTerm
                    .trim()
                    .toLowerCase();

            return assignments.filter(
                item => {

                    const matchesSubject =
                        !filterSubject ||
                        item.subject_name ===
                            filterSubject;

                    const searchableText =
                        [
                            item.title,
                            item.description,
                            item.subject_name,
                            item.grade_class_name,
                            item.teacher_name,
                        ]
                            .filter(
                                Boolean
                            )
                            .join(" ")
                            .toLowerCase();

                    const matchesSearch =
                        !search ||
                        searchableText.includes(
                            search
                        );

                    return (
                        matchesSubject &&
                        matchesSearch
                    );

                }
            );

        }, [
            assignments,
            filterSubject,
            searchTerm,
        ]);


    /* ============================================================
       OPTIONS
    ============================================================ */

    const subjectOptions =
        useMemo(() => {

            const source =
                allSubjects.length
                    ? allSubjects
                    : subjects;

            return source
                .map(subject => {

                    if (
                        typeof subject ===
                        "string"
                    ) {

                        return {
                            label: subject,
                            value: subject,
                        };

                    }

                    return {
                        label:
                            subject.name ||
                            subject.subject_name ||
                            String(
                                subject.id
                            ),

                        value:
                            subject.id ??
                            subject.name ??
                            subject.subject_name,
                    };

                })
                .filter(
                    item =>
                        item.label &&
                        item.value !==
                            undefined
                );

        }, [
            allSubjects,
            subjects,
        ]);


    const gradeClassOptions =
        useMemo(() => {

            return gradeClasses
                .map(item => {

                    if (
                        typeof item ===
                        "string"
                    ) {

                        return {
                            label: item,
                            value: item,
                        };

                    }

                    return {
                        label:
                            item.name ||
                            item.grade_class_name ||
                            item.grade_name ||
                            String(
                                item.id
                            ),

                        value:
                            item.id ??
                            item.name ??
                            item.grade_class_name,
                    };

                })
                .filter(
                    item =>
                        item.label &&
                        item.value !==
                            undefined
                );

        }, [
            gradeClasses,
        ]);


    /* ============================================================
       LIKE
    ============================================================ */

    const handleLike =
        async id => {

            try {

                setActionLoading(
                    prev => ({
                        ...prev,
                        [`like-${id}`]:
                            true,
                    })
                );

                await api.post(
                    `/api/assignments/${id}/like/`
                );

                await fetchAssignments();

            } catch (err) {

                console.error(
                    err
                );

                error(
                    "Unable to update like",
                    "Please try again."
                );

            } finally {

                setActionLoading(
                    prev => ({
                        ...prev,
                        [`like-${id}`]:
                            false,
                    })
                );

            }

        };


    /* ============================================================
       DELETE
    ============================================================ */

    const handleDelete =
        async id => {

            const result =
                await Swal.fire({

                    title:
                        "Delete Assignment?",

                    text:
                        "This action cannot be reversed.",

                    icon: "warning",

                    showCancelButton:
                        true,

                    confirmButtonText:
                        "Yes, delete it",

                    cancelButtonText:
                        "Keep Assignment",

                    confirmButtonColor:
                        colors.danger,

                    cancelButtonColor:
                        colors.primary,

                });

            if (
                !result.isConfirmed
            ) {
                return;
            }

            try {

                setActionLoading(
                    prev => ({
                        ...prev,
                        [`delete-${id}`]:
                            true,
                    })
                );

                await api.delete(
                    `/api/assignments/${id}/`
                );

                setAssignments(
                    prev =>
                        prev.filter(
                            item =>
                                item.id !==
                                id
                        )
                );

                success(
                    "Assignment deleted",
                    "The assignment has been removed."
                );

            } catch (err) {

                console.error(
                    err
                );

                error(
                    "Delete failed",
                    "Unable to delete this assignment."
                );

            } finally {

                setActionLoading(
                    prev => ({
                        ...prev,
                        [`delete-${id}`]:
                            false,
                    })
                );

            }

        };


    /* ============================================================
       NORMALIZE ENTITY VALUE
    ============================================================ */

    const normalizeValue =
        value => {

            if (
                value &&
                typeof value ===
                    "object"
            ) {

                return (
                    value.id ??
                    value.pk ??
                    value.value ??
                    value.name ??
                    null
                );

            }

            return value ??
                null;

        };


    /* ============================================================
       OPEN EDIT
    ============================================================ */

    const openEdit =
        assignment => {

            setEditAssignment(
                assignment
            );

            editForm.setFieldsValue({

                title:
                    assignment.title ||
                    "",

                subject:
                    normalizeValue(
                        assignment.subject ??
                        assignment.subject_id ??
                        assignment.subject_name
                    ),

                grade_class:
                    normalizeValue(
                        assignment.grade_class ??
                        assignment.grade_class_id ??
                        assignment.grade_class_name
                    ),

                due_date:
                    assignment.due_date
                        ? dayjs(
                              assignment.due_date
                          )
                        : null,

                description:
                    assignment.description ||
                    "",

            });

            setEditModalOpen(
                true
            );

        };


    /* ============================================================
       CLOSE EDIT
    ============================================================ */

    const closeEdit =
        () => {

            setEditModalOpen(
                false
            );

            setEditAssignment(
                null
            );

            editForm.resetFields();

        };


    /* ============================================================
       UPDATE
    ============================================================ */

    const handleUpdate =
        async values => {

            if (
                !editAssignment
            ) {
                return;
            }

            try {

                setEditSaving(
                    true
                );

                const payload = {

                    title:
                        values.title
                            ?.trim() ||
                        "",

                    description:
                        values.description
                            ?.trim() ||
                        "",

                    due_date:
                        values.due_date
                            ? values.due_date.format(
                                  "YYYY-MM-DD"
                              )
                            : null,

                    grade_class:
                        values.grade_class,

                    subject:
                        values.subject,

                };

                await api.patch(
                    `/api/assignments/${editAssignment.id}/`,
                    payload
                );

                await fetchAssignments();

                closeEdit();

                success(
                    "Assignment updated",
                    "Your assignment has been updated successfully."
                );

            } catch (err) {

                console.error(
                    "Assignment update error:",
                    err
                );

                error(
                    "Update failed",
                    "Unable to update the assignment."
                );

            } finally {

                setEditSaving(
                    false
                );

            }

        };


    /* ============================================================
       FETCH COMMENTS
    ============================================================ */

    const fetchComments =
        useCallback(
            async assignmentId => {

                try {

                    setCommentsLoading(
                        prev => ({
                            ...prev,
                            [assignmentId]:
                                true,
                        })
                    );

                    const res =
                        await api.get(
                            `/api/assignments/${assignmentId}/comments/`
                        );

                    setCommentsData(
                        prev => ({
                            ...prev,
                            [assignmentId]:
                                Array.isArray(
                                    res.data
                                )
                                    ? res.data
                                    : [],
                        })
                    );

                } catch (err) {

                    console.error(
                        "Comments error:",
                        err
                    );

                    error(
                        "Unable to load comments",
                        "Please try again."
                    );

                } finally {

                    setCommentsLoading(
                        prev => ({
                            ...prev,
                            [assignmentId]:
                                false,
                        })
                    );

                }

            },
            []
        );


    /* ============================================================
       TOGGLE COMMENTS
    ============================================================ */

    const toggleComments =
        async id => {

            const isOpen =
                expandedComments[id];

            if (isOpen) {

                setExpandedComments(
                    prev => ({
                        ...prev,
                        [id]: false,
                    })
                );

                return;
            }

            setExpandedComments(
                prev => ({
                    ...prev,
                    [id]: true,
                })
            );

            await fetchComments(
                id
            );

        };


    /* ============================================================
       POST COMMENT
    ============================================================ */

    const postComment =
        async id => {

            const content =
                commentInput[id];

            if (
                !content ||
                !content.trim()
            ) {
                return;
            }

            try {

                setActionLoading(
                    prev => ({
                        ...prev,
                        [`comment-${id}`]:
                            true,
                    })
                );

                await api.post(
                    `/api/assignments/${id}/comments/`,
                    {
                        content:
                            content.trim(),
                    }
                );

                setCommentInput(
                    prev => ({
                        ...prev,
                        [id]: "",
                    })
                );

                setExpandedComments(
                    prev => ({
                        ...prev,
                        [id]: true,
                    })
                );

                await fetchComments(
                    id
                );

                await fetchAssignments();

            } catch (err) {

                console.error(
                    "Comment error:",
                    err
                );

                error(
                    "Comment failed",
                    "Unable to post your comment."
                );

            } finally {

                setActionLoading(
                    prev => ({
                        ...prev,
                        [`comment-${id}`]:
                            false,
                    })
                );

            }

        };


    /* ============================================================
       POST REPLY
    ============================================================ */

    const postReply =
        async (
            assignmentId,
            commentId
        ) => {

            const content =
                replyInput[
                    commentId
                ];

            if (
                !content ||
                !content.trim()
            ) {
                return;
            }

            try {

                setActionLoading(
                    prev => ({
                        ...prev,
                        [`reply-${commentId}`]:
                            true,
                    })
                );

                await api.post(
                    `/api/assignments/${assignmentId}/comments/${commentId}/reply/`,
                    {
                        content:
                            content.trim(),
                    }
                );

                setReplyInput(
                    prev => ({
                        ...prev,
                        [commentId]: "",
                    })
                );

                await fetchComments(
                    assignmentId
                );

                setActiveReplyBox(
                    null
                );

                await fetchAssignments();

            } catch (err) {

                console.error(
                    "Reply error:",
                    err
                );

                error(
                    "Reply failed",
                    "Unable to post your reply."
                );

            } finally {

                setActionLoading(
                    prev => ({
                        ...prev,
                        [`reply-${commentId}`]:
                            false,
                    })
                );

            }

        };


    /* ============================================================
       DEADLINE
    ============================================================ */

    const getDeadlineInfo =
        dueDate => {

            if (!dueDate) {

                return {
                    label:
                        "No deadline",

                    color:
                        colors.muted,

                    background:
                        colors.soft,

                    icon:
                        <CalendarOutlined />,
                };

            }

            const date =
                dayjs(dueDate);

            if (
                !date.isValid()
            ) {

                return {
                    label:
                        "No deadline",

                    color:
                        colors.muted,

                    background:
                        colors.soft,

                    icon:
                        <CalendarOutlined />,
                };

            }

            const today =
                dayjs().startOf(
                    "day"
                );

            const deadline =
                date.startOf(
                    "day"
                );

            const difference =
                deadline.diff(
                    today,
                    "day"
                );

            if (
                difference < 0
            ) {

                return {
                    label:
                        `Overdue • ${date.format(
                            "MMM D, YYYY"
                        )}`,

                    color:
                        colors.danger,

                    background:
                        "#FFF1F0",

                    icon:
                        <ExclamationCircleOutlined />,
                };

            }

            if (
                difference === 0
            ) {

                return {
                    label:
                        `Due today • ${date.format(
                            "MMM D, YYYY"
                        )}`,

                    color:
                        colors.orange,

                    background:
                        "#FFF7E6",

                    icon:
                        <ClockCircleOutlined />,
                };

            }

            if (
                difference === 1
            ) {

                return {
                    label:
                        `Due tomorrow • ${date.format(
                            "MMM D, YYYY"
                        )}`,

                    color:
                        colors.gold,

                    background:
                        "#FFFBE6",

                    icon:
                        <ClockCircleOutlined />,
                };

            }

            return {
                label:
                    `Due ${date.format(
                        "MMM D, YYYY"
                    )}`,

                color:
                    colors.primary,

                background:
                    "#EAF5F2",

                icon:
                    <CheckCircleOutlined />,
            };

        };


    /* ============================================================
       COMMENT RENDERER
    ============================================================ */

    const renderComments =
        assignment => {

            const id =
                assignment.id;

            const comments =
                commentsData[id] ||
                [];

            const isLoading =
                commentsLoading[id];

            const count =
                assignment.comments_count ??
                comments.length ??
                0;

            return (

                <div className="assignment-discussion">

                    {/* DISCUSSION HEADER */}

                    <div className="discussion-header">

                        <div className="discussion-heading">

                            <div className="discussion-icon">
                                <CommentOutlined />
                            </div>

                            <div>

                                <span className="discussion-title">
                                    Discussion
                                </span>

                                <span className="discussion-subtitle">
                                    Join the conversation
                                    around this assignment
                                </span>

                            </div>

                        </div>

                        <Badge
                            count={count}
                            overflowCount={99}
                            className="discussion-count"
                        />

                    </div>


                    {/* COMMENT COMPOSER */}

                    <div className="comment-composer">

                        <Avatar
                            size={40}
                            src={
                                teacher?.profile_image ||
                                defaultAvatar
                            }
                            icon={
                                <UserOutlined />
                            }
                            className="composer-avatar"
                        />

                        <div className="composer-content">

                            <div className="composer-box">

                                <TextArea
                                    autoSize={{
                                        minRows: 1,
                                        maxRows: 5,
                                    }}
                                    placeholder="Write a thoughtful comment..."
                                    value={
                                        commentInput[
                                            id
                                        ] || ""
                                    }
                                    onChange={e =>
                                        setCommentInput(
                                            prev => ({
                                                ...prev,
                                                [id]:
                                                    e.target
                                                        .value,
                                            })
                                        )
                                    }
                                    onPressEnter={e => {

                                        if (
                                            !e.shiftKey
                                        ) {

                                            e.preventDefault();

                                            postComment(
                                                id
                                            );

                                        }

                                    }}
                                />

                                <Tooltip title="Post comment">

                                    <Button
                                        type="primary"
                                        shape="circle"
                                        icon={
                                            <SendOutlined />
                                        }
                                        className="comment-send"
                                        loading={
                                            actionLoading[
                                                `comment-${id}`
                                            ]
                                        }
                                        disabled={
                                            !commentInput[
                                                id
                                            ]?.trim()
                                        }
                                        onClick={() =>
                                            postComment(
                                                id
                                            )
                                        }
                                    />

                                </Tooltip>

                            </div>

                        </div>

                    </div>


                    {/* COMMENTS */}

                    {isLoading ? (

                        <div
                            style={{
                                marginTop: 22,
                            }}
                        >

                            <Skeleton
                                avatar={{
                                    size: 39,
                                }}
                                active
                                paragraph={{
                                    rows: 2,
                                }}
                            />

                            <Skeleton
                                avatar={{
                                    size: 39,
                                }}
                                active
                                paragraph={{
                                    rows: 2,
                                }}
                            />

                        </div>

                    ) : comments.length === 0 ? (

                        <div className="discussion-empty">

                            <div className="discussion-empty-icon">
                                <MessageOutlined />
                            </div>

                            <div className="discussion-empty-title">
                                Join the conversation
                            </div>

                            <div className="discussion-empty-text">
                                Be the first to comment.
                                Ask a question, share
                                an idea, or help a
                                classmate understand
                                the assignment.
                            </div>

                            <Button
                                type="text"
                                className="discussion-empty-action"
                                onClick={() => {

                                    const input =
                                        document.querySelector(
                                            ".composer-box textarea"
                                        );

                                    input?.focus();

                                }}
                            >
                                Start the discussion
                                <ArrowRightOutlined
                                    style={{
                                        marginLeft: 5,
                                    }}
                                />
                            </Button>

                        </div>

                    ) : (

                        <div className="comment-list">

                            {comments.map(
                                comment => (

                                    <div
                                        key={
                                            comment.id
                                        }
                                        className="comment-item"
                                    >

                                        {/* AVATAR */}

                                        <Avatar
                                            size={39}
                                            src={
                                                comment.user
                                                    ?.profile_image ||
                                                comment.profile_image ||
                                                defaultAvatar
                                            }
                                            icon={
                                                <UserOutlined />
                                            }
                                            className="comment-avatar"
                                        />


                                        {/* COMMENT CONTENT */}

                                        <div className="comment-content">

                                            <div className="comment-bubble">

                                                <div className="comment-author-line">

                                                    <span className="comment-author">
                                                        {
                                                            comment.username ||
                                                            comment.user
                                                                ?.username ||
                                                            "Student"
                                                        }
                                                    </span>

                                                    {comment.is_teacher && (

                                                        <span className="comment-role">
                                                            Teacher
                                                        </span>

                                                    )}

                                                </div>

                                                <div className="comment-text">
                                                    {
                                                        comment.content
                                                    }
                                                </div>

                                            </div>


                                            {/* COMMENT META */}

                                            <div className="comment-meta">

                                                <span className="comment-time">
                                                    {comment.created_at
                                                        ? dayjs(
                                                              comment.created_at
                                                          ).fromNow()
                                                        : "Just now"}
                                                </span>

                                                <Button
                                                    type="text"
                                                    className="comment-meta-button"
                                                    onClick={() =>
                                                        setActiveReplyBox(
                                                            activeReplyBox ===
                                                                comment.id
                                                                ? null
                                                                : comment.id
                                                        )
                                                    }
                                                >
                                                    Reply
                                                </Button>

                                                <span
                                                    style={{
                                                        color:
                                                            "#B3BFBC",
                                                        fontSize:
                                                            10,
                                                    }}
                                                >
                                                    •
                                                </span>

                                                <span
                                                    style={{
                                                        color:
                                                            "#94A19E",
                                                        fontSize:
                                                            10,
                                                    }}
                                                >
                                                    Join the
                                                    conversation
                                                </span>

                                            </div>


                                            {/* REPLY COMPOSER */}

                                            {activeReplyBox ===
                                                comment.id && (

                                                <div className="reply-composer">

                                                    <Avatar
                                                        size={31}
                                                        src={
                                                            teacher?.profile_image ||
                                                            defaultAvatar
                                                        }
                                                        icon={
                                                            <UserOutlined />
                                                        }
                                                        className="reply-composer-avatar"
                                                    />

                                                    <div className="reply-input-box">

                                                        <Input
                                                            value={
                                                                replyInput[
                                                                    comment.id
                                                                ] ||
                                                                ""
                                                            }
                                                            onChange={e =>
                                                                setReplyInput(
                                                                    prev => ({
                                                                        ...prev,
                                                                        [comment.id]:
                                                                            e
                                                                                .target
                                                                                .value,
                                                                    })
                                                                )
                                                            }
                                                            placeholder={`Reply to ${
                                                                comment.username ||
                                                                comment.user
                                                                    ?.username ||
                                                                "this comment"
                                                            }...`}
                                                            onPressEnter={e => {

                                                                if (
                                                                    !e.shiftKey
                                                                ) {

                                                                    e.preventDefault();

                                                                    postReply(
                                                                        id,
                                                                        comment.id
                                                                    );

                                                                }

                                                            }}
                                                        />

                                                        <Tooltip title="Send reply">

                                                            <Button
                                                                type="text"
                                                                shape="circle"
                                                                icon={
                                                                    <SendOutlined />
                                                                }
                                                                className="reply-send"
                                                                loading={
                                                                    actionLoading[
                                                                        `reply-${comment.id}`
                                                                    ]
                                                                }
                                                                disabled={
                                                                    !replyInput[
                                                                        comment.id
                                                                    ]?.trim()
                                                                }
                                                                onClick={() =>
                                                                    postReply(
                                                                        id,
                                                                        comment.id
                                                                    )
                                                                }
                                                            />

                                                        </Tooltip>

                                                    </div>

                                                </div>

                                            )}


                                            {/* REPLIES */}

                                            {comment.replies?.length >
                                                0 && (

                                                <div className="replies">

                                                    {comment.replies.map(
                                                        reply => (

                                                            <div
                                                                key={
                                                                    reply.id
                                                                }
                                                                className="reply-item"
                                                            >

                                                                <Avatar
                                                                    size={31}
                                                                    src={
                                                                        reply.user
                                                                            ?.profile_image ||
                                                                        reply.profile_image ||
                                                                        defaultAvatar
                                                                    }
                                                                    icon={
                                                                        <UserOutlined />
                                                                    }
                                                                    className="reply-avatar"
                                                                />

                                                                <div className="reply-content">

                                                                    <div className="reply-bubble">

                                                                        <div className="reply-author">

                                                                            {
                                                                                reply.username ||
                                                                                reply.user
                                                                                    ?.username ||
                                                                                "Student"
                                                                            }

                                                                            {reply.is_teacher && (

                                                                                <span className="comment-role">
                                                                                    Teacher
                                                                                </span>

                                                                            )}

                                                                        </div>

                                                                        <div className="reply-text">
                                                                            {
                                                                                reply.content
                                                                            }
                                                                        </div>

                                                                    </div>

                                                                    <div className="reply-meta">

                                                                        <span>
                                                                            {reply.created_at
                                                                                ? dayjs(
                                                                                      reply.created_at
                                                                                  ).fromNow()
                                                                                : "Just now"}
                                                                        </span>

                                                                        <span>
                                                                            •
                                                                        </span>

                                                                        <span>
                                                                            Reply
                                                                        </span>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                        )
                                                    )}

                                                </div>

                                            )}

                                        </div>

                                    </div>

                                )
                            )}

                        </div>

                    )}

                </div>

            );

        };


    /* ============================================================
       ASSIGNMENT RENDERER
    ============================================================ */

    const renderAssignment =
        assignment => {

            const deadline =
                getDeadlineInfo(
                    assignment.due_date
                );

            const isLiked =
                Boolean(
                    assignment.liked
                );

            return (

                <Card
                    key={
                        assignment.id
                    }
                    className="assignment-card"
                >

                    {/* POST HEADER */}

                    <div className="post-header">

                        <Avatar
                            size={49}
                            src={
                                assignment.teacher_image ||
                                teacher?.profile_image ||
                                defaultAvatar
                            }
                            icon={
                                <UserOutlined />
                            }
                            className="post-avatar"
                        />

                        <div className="post-author-area">

                            <div className="post-author-line">

                                <span className="post-author-name">
                                    {
                                        assignment.teacher_name ||
                                        "Teacher"
                                    }
                                </span>

                                <Tag className="teacher-badge">
                                    TEACHER
                                </Tag>

                            </div>

                            <span className="post-context">
                                Shared an assignment
                            </span>

                        </div>

                        <Tooltip title="Assignment post">

                            <Button
                                type="text"
                                shape="circle"
                                icon={
                                    <MoreOutlined />
                                }
                                className="post-menu"
                            />

                        </Tooltip>

                    </div>


                    {/* ASSIGNMENT BODY */}

                    <div className="assignment-content">

                        <Title
                            level={3}
                            className="assignment-title"
                        >
                            {
                                assignment.title ||
                                "Untitled Assignment"
                            }
                        </Title>


                        <div className="assignment-intro">

                            Here's a classroom
                            activity shared with
                            the learning community.
                            Review the instructions,
                            participate, and use the
                            discussion below when you
                            need clarification.

                        </div>


                        {/* META */}

                        <div className="assignment-meta">

                            {assignment.subject_name && (

                                <Tag
                                    icon={
                                        <BookOutlined />
                                    }
                                    className="assignment-tag"
                                    style={{
                                        background:
                                            "#EAF5F2",
                                        borderColor:
                                            "#CBE3DE",
                                        color:
                                            colors.primary,
                                    }}
                                >
                                    {
                                        assignment.subject_name
                                    }
                                </Tag>

                            )}

                            {assignment.grade_class_name && (

                                <Tag
                                    icon={
                                        <TeamOutlined />
                                    }
                                    className="assignment-tag"
                                    style={{
                                        background:
                                            "#EEF6FC",
                                        borderColor:
                                            "#D5E7F5",
                                        color:
                                            colors.blue,
                                    }}
                                >
                                    {
                                        assignment.grade_class_name
                                    }
                                </Tag>

                            )}

                        </div>


                        {/* DESCRIPTION */}

                        {assignment.description ? (

                            <Paragraph
                                className="assignment-description"
                            >
                                {
                                    assignment.description
                                }
                            </Paragraph>

                        ) : (

                            <div className="assignment-description">

                                No additional instructions
                                have been added yet. Students
                                can use the discussion space
                                below to ask questions or
                                share helpful ideas.

                            </div>

                        )}


                        {/* COMMUNITY PLACEHOLDER */}

                        <div className="assignment-community-note">

                            <div className="community-note-icon">
                                <MessageOutlined />
                            </div>

                            <div>

                                <span className="community-note-title">
                                    Learning together
                                </span>

                                <span className="community-note-text">
                                    Ask questions, exchange
                                    ideas, and help classmates
                                    understand the assignment.
                                </span>

                            </div>

                        </div>


                        {/* DEADLINE */}

                        <div
                            className="assignment-deadline"
                            style={{
                                background:
                                    deadline.background,

                                borderColor:
                                    `${deadline.color}22`,
                            }}
                        >

                            <div
                                className="deadline-icon"
                                style={{
                                    color:
                                        deadline.color,
                                }}
                            >
                                {
                                    deadline.icon
                                }
                            </div>

                            <div>

                                <span className="deadline-label">
                                    Assignment deadline
                                </span>

                                <span
                                    className="deadline-value"
                                    style={{
                                        color:
                                            deadline.color,
                                    }}
                                >
                                    {
                                        deadline.label
                                    }
                                </span>

                            </div>

                        </div>

                    </div>


                    {/* ACTION BAR */}

                    <div className="assignment-actions">

                        <div className="action-group">

                            <Button
                                type="text"
                                className={`
                                    social-action
                                    ${
                                        isLiked
                                            ? "social-action-liked"
                                            : ""
                                    }
                                `}
                                icon={
                                    isLiked
                                        ? <LikeFilled />
                                        : <LikeOutlined />
                                }
                                loading={
                                    actionLoading[
                                        `like-${assignment.id}`
                                    ]
                                }
                                onClick={() =>
                                    handleLike(
                                        assignment.id
                                    )
                                }
                            >
                                <span className="action-label">
                                    {
                                        assignment.likes_count ||
                                        0
                                    }{" "}
                                    Likes
                                </span>
                            </Button>


                            <Button
                                type="text"
                                className="social-action"
                                icon={
                                    <MessageOutlined />
                                }
                                onClick={() =>
                                    toggleComments(
                                        assignment.id
                                    )
                                }
                            >
                                <span className="action-label">
                                    {
                                        assignment.comments_count ||
                                        0
                                    }{" "}
                                    Comments
                                </span>
                            </Button>

                        </div>


                        {assignment.can_edit && (

                            <div className="action-group">

                                <div className="action-divider" />

                                <Tooltip title="Edit assignment">

                                    <Button
                                        type="text"
                                        className="social-action"
                                        icon={
                                            <EditOutlined />
                                        }
                                        onClick={() =>
                                            openEdit(
                                                assignment
                                            )
                                        }
                                    />

                                </Tooltip>

                                <Tooltip title="Delete assignment">

                                    <Button
                                        type="text"
                                        danger
                                        className="social-action"
                                        icon={
                                            <DeleteOutlined />
                                        }
                                        loading={
                                            actionLoading[
                                                `delete-${assignment.id}`
                                            ]
                                        }
                                        onClick={() =>
                                            handleDelete(
                                                assignment.id
                                            )
                                        }
                                    />

                                </Tooltip>

                            </div>

                        )}

                    </div>


                    {/* DISCUSSION */}

                    {expandedComments[
                        assignment.id
                    ] && renderComments(
                        assignment
                    )}

                </Card>

            );

        };


    /* ============================================================
       MAIN UI
    ============================================================ */

    return (

        <ConfigProvider
            theme={{
                token: {
                    colorPrimary:
                        colors.primary,

                    colorSuccess:
                        colors.green,

                    colorInfo:
                        colors.teal,

                    borderRadius:
                        12,

                    fontSize:
                        14,
                },
            }}
        >

            <Layout
                className="assignment-page"
                style={{
                    padding:
                        "18px 12px 50px",
                }}
            >

                <div className="assignment-shell">


                    {/* ==================================================
                        COMMUNITY HERO
                    ================================================== */}

                    <Card
                        bordered={false}
                        className="community-hero"
                        styles={{
                            body: {
                                padding: 0,
                            },
                        }}
                    >

                        <div className="community-hero-body">

                            <div className="community-profile">

                                <Avatar
                                    size={82}
                                    src={
                                        teacher?.profile_image ||
                                        defaultAvatar
                                    }
                                    icon={
                                        <UserOutlined />
                                    }
                                    className="community-profile-avatar"
                                />

                                <div className="community-profile-copy">

                                    <span className="community-eyebrow">
                                        Salvation In Christ Students Learning Community
                                    </span>

                                    <Title
                                        level={2}
                                        className="community-name"
                                    >
                                        {
                                            teacher?.username ||
                                            "Teacher"
                                        }
                                    </Title>

                                    <Text className="community-description">
                                        Share assignments,
                                        exchange ideas,
                                        support classmates,
                                        and keep the learning
                                        conversation moving.
                                    </Text>

                                </div>

                                <div className="community-status">

                                    <span className="community-status-dot" />

                                    Assignment Community

                                </div>

                            </div>

                        </div>

                    </Card>


                    {/* ==================================================
                        DISCOVERY
                    ================================================== */}

                    <Card
                        bordered={false}
                        className="community-discovery"
                        styles={{
                            body: {
                                padding: 0,
                            },
                        }}
                    >

                        <Row
                            align="middle"
                            gutter={[
                                18,
                                16,
                            ]}
                        >

                            <Col
                                xs={24}
                                md={9}
                            >

                                <Title
                                    level={4}
                                    className="discovery-title"
                                >
                                    Discover & Discuss
                                </Title>

                                <Text className="discovery-description">
                                    Find classroom assignments
                                    and join the conversation.
                                </Text>

                            </Col>


                            <Col
                                xs={24}
                                md={15}
                            >

                                <div className="discovery-controls">

                                    <Input
                                        allowClear
                                        prefix={
                                            <SearchOutlined
                                                style={{
                                                    color:
                                                        "#8AA19C",
                                                }}
                                            />
                                        }
                                        placeholder="Search assignments..."
                                        value={
                                            searchTerm
                                        }
                                        onChange={e =>
                                            setSearchTerm(
                                                e.target
                                                    .value
                                            )
                                        }
                                        className="community-search"
                                    />


                                    <Select
                                        allowClear
                                        size="large"
                                        className="subject-filter"
                                        placeholder="All subjects"
                                        value={
                                            filterSubject ||
                                            undefined
                                        }
                                        onChange={
                                            setFilterSubject
                                        }
                                        options={
                                            subjects.map(
                                                subject => ({
                                                    label:
                                                        subject,
                                                    value:
                                                        subject,
                                                })
                                            )
                                        }
                                        suffixIcon={
                                            <BookOutlined />
                                        }
                                    />


                                    <Tooltip title="Refresh assignments">

                                        <Button
                                            icon={
                                                <ReloadOutlined />
                                            }
                                            className="refresh-button"
                                            onClick={() =>
                                                fetchAssignments()
                                            }
                                        />

                                    </Tooltip>

                                </div>

                            </Col>

                        </Row>

                    </Card>


                    {/* ==================================================
                        FEED
                    ================================================== */}

                    {loading ? (

                        <div className="assignment-feed">

                            {[1, 2].map(
                                item => (

                                    <Card
                                        key={item}
                                        className="assignment-card"
                                        styles={{
                                            body: {
                                                padding: 23,
                                            },
                                        }}
                                        style={{
                                            marginBottom: 18,
                                        }}
                                    >

                                        <Skeleton
                                            avatar={{
                                                size: 50,
                                            }}
                                            active
                                            paragraph={{
                                                rows: 5,
                                            }}
                                        />

                                    </Card>

                                )
                            )}

                        </div>

                    ) : filteredAssignments.length ===
                      0 ? (

                        <div className="assignment-feed">

                            <div className="feed-empty">

                                <Empty
                                    image={
                                        Empty.PRESENTED_IMAGE_SIMPLE
                                    }
                                    description={null}
                                />

                                <div
                                    style={{
                                        textAlign:
                                            "center",
                                    }}
                                >

                                    <Text
                                        strong
                                        style={{
                                            display:
                                                "block",
                                            color:
                                                colors.text,
                                            fontSize:
                                                17,
                                        }}
                                    >
                                        No assignments
                                        found
                                    </Text>

                                    <Text
                                        type="secondary"
                                        style={{
                                            display:
                                                "block",
                                            marginTop:
                                                5,
                                            fontSize:
                                                13,
                                        }}
                                    >
                                        {searchTerm ||
                                        filterSubject
                                            ? "Try changing your search or subject filter."
                                            : "There are no assignments available right now."}
                                    </Text>

                                    {(searchTerm ||
                                        filterSubject) && (

                                        <Button
                                            type="primary"
                                            style={{
                                                marginTop:
                                                    14,
                                                background:
                                                    colors.primary,
                                            }}
                                            onClick={() => {

                                                setSearchTerm(
                                                    ""
                                                );

                                                setFilterSubject(
                                                    ""
                                                );

                                            }}
                                        >
                                            Clear Filters
                                        </Button>

                                    )}

                                </div>

                            </div>

                        </div>

                    ) : (

                        <div className="assignment-feed">

                            <div className="feed-heading">

                                <span className="feed-heading-label">
                                    Community Feed
                                </span>

                                <span className="feed-heading-count">
                                    {
                                        filteredAssignments.length
                                    }{" "}
                                    {filteredAssignments.length ===
                                    1
                                        ? "assignment"
                                        : "assignments"}
                                </span>

                            </div>


                            <div
                                style={{
                                    display:
                                        "flex",
                                    flexDirection:
                                        "column",
                                    gap: 20,
                                }}
                            >

                                {filteredAssignments.map(
                                    renderAssignment
                                )}

                            </div>

                        </div>

                    )}


                    {/* ==================================================
                        EDIT MODAL
                    ================================================== */}

                    <Modal
                        open={
                            editModalOpen
                        }
                        onCancel={
                            closeEdit
                        }
                        centered
                        width={620}
                        destroyOnClose
                        footer={null}
                        className="assignment-modal"
                        title={

                            <div className="modal-heading">

                                <div className="modal-heading-icon">
                                    <EditOutlined />
                                </div>

                                <div>

                                    <Text
                                        strong
                                        style={{
                                            display:
                                                "block",
                                            color:
                                                colors.text,
                                            fontSize:
                                                17,
                                        }}
                                    >
                                        Edit Assignment
                                    </Text>

                                    <Text
                                        type="secondary"
                                        style={{
                                            fontSize:
                                                12,
                                        }}
                                    >
                                        Update the assignment
                                        details below.
                                    </Text>

                                </div>

                            </div>

                        }
                    >

                        <Form
                            form={editForm}
                            layout="vertical"
                            onFinish={
                                handleUpdate
                            }
                        >

                            <Form.Item
                                label="Assignment Title"
                                name="title"
                                rules={[
                                    {
                                        required:
                                            true,
                                        message:
                                            "Please enter an assignment title.",
                                    },
                                ]}
                            >

                                <Input
                                    size="large"
                                    placeholder="Enter assignment title"
                                />

                            </Form.Item>


                            <Row
                                gutter={[
                                    12,
                                    0,
                                ]}
                            >

                                <Col
                                    xs={24}
                                    md={12}
                                >

                                    <Form.Item
                                        label="Subject"
                                        name="subject"
                                    >

                                        <Select
                                            size="large"
                                            showSearch
                                            allowClear
                                            placeholder="Select subject"
                                            options={
                                                subjectOptions
                                            }
                                        />

                                    </Form.Item>

                                </Col>


                                <Col
                                    xs={24}
                                    md={12}
                                >

                                    <Form.Item
                                        label="Grade / Class"
                                        name="grade_class"
                                    >

                                        <Select
                                            size="large"
                                            showSearch
                                            allowClear
                                            placeholder="Select grade/class"
                                            options={
                                                gradeClassOptions
                                            }
                                        />

                                    </Form.Item>

                                </Col>

                            </Row>


                            <Form.Item
                                label="Due Date"
                                name="due_date"
                            >

                                <DatePicker
                                    size="large"
                                    style={{
                                        width:
                                            "100%",
                                    }}
                                    format="YYYY-MM-DD"
                                />

                            </Form.Item>


                            <Form.Item
                                label="Description"
                                name="description"
                                rules={[
                                    {
                                        required:
                                            true,
                                        message:
                                            "Please enter the assignment description.",
                                    },
                                ]}
                            >

                                <TextArea
                                    rows={6}
                                    showCount
                                    maxLength={2000}
                                    placeholder="Write clear instructions for your students..."
                                />

                            </Form.Item>


                            <Row
                                justify="end"
                                gutter={[
                                    10,
                                    10,
                                ]}
                            >

                                <Col>

                                    <Button
                                        size="large"
                                        onClick={
                                            closeEdit
                                        }
                                    >
                                        Cancel
                                    </Button>

                                </Col>


                                <Col>

                                    <Button
                                        size="large"
                                        type="primary"
                                        htmlType="submit"
                                        loading={
                                            editSaving
                                        }
                                        icon={
                                            <CheckCircleOutlined />
                                        }
                                        style={{
                                            background:
                                                colors.primary,
                                            borderColor:
                                                colors.primary,
                                        }}
                                    >
                                        Save Changes
                                    </Button>

                                </Col>

                            </Row>

                        </Form>

                    </Modal>

                </div>

            </Layout>

        </ConfigProvider>
    );
};

export default AssignmentView;